import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Message, SelectItem } from 'primeng/api';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { PlanoContaGrupo } from 'src/app/admihair/api/dto/plano-conta-grupo';
import { PlanoContaMatriz } from 'src/app/admihair/api/dto/plano-conta-matriz';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { PlanoContaGrupoService } from 'src/app/admihair/service/plano-conta-grupo.service';
import { PlanoContaMatrizService } from 'src/app/admihair/service/plano-conta-matriz.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-plano-conta-matriz-editar',
  templateUrl: './plano-contas-matriz-editar.component.html',
  styleUrls: ['./plano-contas-matriz-editar.component.scss']
})
export class PlanoContaMatrizEditarComponent implements OnInit {

  id?: number;
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  planoContaMatriz?: PlanoContaMatriz;
  planosContaGrupos: PlanoContaGrupo[] = [];
  prioridades: SelectItem[] = [{label: 'SIM', value: 1}, {label: 'NÃO', value: 0}];

  categoriasDre: string[] = ['CUSTOS FIXOS DIRETOS', 'CUSTOS FIXOS INDIRETOS',
     'CUSTOS VARIÁVEIS DIRETOS', 'CUSTOS VARIÁVEIS INDIRETOS', 'DESPESAS',
      'RECEITAS', 'NÃO PRESENTE'];

  utilizacoes: string[] = ['FOLHA DE PAGAMENTO', 'DESPESA', 'FOLHA/DESPESA', 'NÃO APLICADO' ];

  categoriasPatrimonial: string[] = ['ATIVO CIRCULANTE', 'ATIVO NÃO CIRCULANTE', 'PASSIVO CIRCULANTE',
     'PASSIVO NÃO CIRCULANTE', 'NÃO SE APLICA'];

  referenciasFolha: string[] = ['CREDITO', 'DESCONTO', 'NÃO APLICADO' ];
  loadingPlanoConta: boolean = false;
  progressoRequisicaoAtualizar: boolean = false;
  loadingContaEmpresa: boolean = false;
  contaEditada: boolean = false;

  constructor(private planoContaGrupoService: PlanoContaGrupoService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private utilStorageService: UtilStorageService,
    private planoContaMatrizService: PlanoContaMatrizService,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;
  value?: string;

  ngOnInit(): void {
    this.loadingPlanoConta = true;
    this.buscarIdPlanoContaMatriz();
    this.listarPlanosContaGrupos();
  }

  atualizar(){
    this.progressoRequisicaoAtualizar = true;
    console.log(this.planoContaMatriz)
    this.planoContaMatrizService.atualizar(this.planoContaMatriz).subscribe({
      next: () => {
        this.progressoRequisicaoAtualizar = false;
        this.contaEditada = true;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicaoAtualizar = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
    
  }

  atualizarEmpresas(){
    this.loadingContaEmpresa = true;
    this.planoContaEmpresaService.atualizarPorCodigoMatriz(this.id).subscribe({
      next: (data: PlanoContaEmpresa[]) => {
        this.loadingContaEmpresa = false;
        this.contaEditada = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.loadingContaEmpresa = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })

  }

  buscarPlanoContaMatriz() {
    this.planoContaMatrizService.buscarPorId(this.id).subscribe({
      next: (data: PlanoContaMatriz) => {
        this.planoContaMatriz = data;
        this.loadingPlanoConta = false;
      },
      error: (err: any) => {
        this.loadingPlanoConta = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  listarPlanosContaGrupos(){
    this.planoContaGrupoService.listarTodos().subscribe({
      next: (data: PlanoContaGrupo[]) => {
        this.planosContaGrupos = data;
        this.buscarPlanoContaMatriz();
      },
      error: (err: any) => {
        this.loadingPlanoConta = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  buscarIdPlanoContaMatriz(){
    const idParam = this.activatedRoute.snapshot.paramMap.get('id');
    if(idParam) this.id = parseInt(idParam);
  }


  limparFormulario(){
    this.form?.reset(); 
  }
  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
 
}